<template>
    <!DOCTYPE html>
    <html lang="en">
    <body>
        <page-header></page-header>
        <div>
            <div class="import-tasks-modal">
                <div class="tasks-container-fluid no-padding">
                    <div class="row">
                        <div class="col-md-12 left-align-text">
                            <h2>Import tasks from .CSV file</h2>
                            <button class="back-button" @click="goBack()">Back</button>
                            <p style="font-size:16px;">The file has to be a spreadsheet file (.csv) in the following
                                format:
                            </p>
                            <p style="font-weight:bold;">ATA|Task No|MT/AT|Scope|Description|Reference|P1|P2|Category
                            </p>
                            <p style="font-size:16px; color: rgb(196, 0, 0);"><b>All fields are mandatory.</b></p>
                            <div class="instructions-area">
                                <table class="inst-table">
                                    <thead>
                                        <tr>
                                            <th>Column</th>
                                            <th>Name</th>
                                            <th>Instructions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>ATA</td>
                                            <td>A valid ATA chapter Number</td>
                                        </tr>
                                        <tr>
                                            <td>B</td>
                                            <td>Task No</td>
                                            <td>A unique number to identify the tasks</td>
                                        </tr>
                                        <tr>
                                            <td>C</td>
                                            <td>MT/AT</td>
                                            <td>The Task Categories. This determines whether the task is a Main Task or
                                                Optional</td>
                                        </tr>
                                        <tr>
                                            <td>D</td>
                                            <td>Scope</td>
                                            <td>Task Codes such as: LOC/INS/SGH/TS/FOT/MEL.</td>
                                        </tr>
                                        <tr>
                                            <td>E</td>
                                            <td>Description</td>
                                            <td>Task Subject/Description</td>
                                        </tr>
                                        <tr>
                                            <td>F</td>
                                            <td>Reference</td>
                                            <td>Manual Reference of the Task. Can contain the chapter #, topic #,
                                                section #</td>
                                        </tr>
                                        <!-- <tr>
                                            <td>G</td>
                                            <td>Skill</td>
                                            <td>The required skill of the trainee to perform the task.</td>
                                        </tr>
                                        <tr>
                                            <td>H</td>
                                            <td>P1</td>
                                            <td>Put an "x" in the field if the task can be performed on a Synthetic
                                                Training Device (STD)</td>
                                        </tr>
                                        <tr>
                                            <td>I</td>
                                            <td>P2</td>
                                            <td>Put an "x" in the field where this applies</td>
                                        </tr> -->
                                        <tr>
                                            <td>G</td>
                                            <td>Category</td>
                                            <td>Category of the task (B1, B2 etc.)</td>
                                        </tr>
                                        <!-- <tr>
                                            <td>I</td>
                                            <td>Assessable</td>
                                            <td>A value 1 or 0. A value of 1 indicates an assessment task</td>
                                        </tr> -->
                                    </tbody>
                                </table>
                                <span class="clip" role="img" aria-label="Paperclip">&#x1F4CE;</span>
                                <input type="file" @change="importFile" class="file-input" />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div v-if="previewRows.length && !importSuccessful && !dryRunSuccessful">
                                <h4 style="text-align: left;">CSV Preview (First 5 rows):</h4>
                                <table class="preview-table">
                                    <!-- Uploaded CSV headers (dynamic) -->
                                    <thead>
                                        <tr>
                                            <th class="narrow-column">ATA</th>
                                            <th class="narrow-column">Task No</th>
                                            <th class="narrow-column">MT/AT</th>
                                            <th class="narrow-column">Scope</th>
                                            <th class="wide-column">Description</th>
                                            <th class="skill-column">Reference</th>
                                            <!-- <th class="skill-column">Skill</th>
                                            <th class="narrow-column">P1</th>
                                            <th class="narrow-column">P2</th> -->
                                            <th class="narrow-column">Category</th>
                                            <!-- <th class="narrow-column">Assessable</th> -->
                                        </tr>
                                    </thead>
                                    <!-- Uploaded CSV preview -->
                                    <tbody>
                                        <tr v-for="(row, index) in previewRows" :key="row.toString()"
                                            v-show="!(ignoreFirstRow && index === 0)">
                                            <td style="font-size:14px" v-for="cell in row" :key="cell">{{ cell }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="dryRunSuccessful" v-html="successMessage.replace(/\n/g, '<br>')"
                                class="successBox">
                            </div>
                            <div v-if="importSuccessful && !dryRun" v-html="successMessage.replace(/\n/g, '<br>')"
                                class="successBox"></div>
                        </div>
                        <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                            <div v-if="errorMessage">{{ errorMessage }}</div>
                        </div>
                        <div class="importArea">
                            <label>
                                <input type="checkbox" v-model="ignoreFirstRow" class="ignoreCheckbox">
                                Ignore first row
                            </label>
                            <label>
                                <input type="checkbox" v-model="dryRun" class="dryRuncheckbox">
                                Dry Run
                            </label>
                            <div class="buttonContainer">
                                <button class="importButton" :disabled="processing" @click.stop.prevent="handleImport">
                                    {{ processing ? 'Importing...' : 'IMPORT' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>

    </html>
</template>

<script>
import axios from 'axios';
import pageHeader from '@/components/Examiner/Header.vue';
import './importTasks.css';
import Papa from 'papaparse';

export default {
    name: "importTasks",
    data() {
        return {
            productId: this.$route.params.productId,
            previewRows: [],
            entireFileRows: [],
            ignoreFirstRow: false,
            importSuccessful: false,
            dryRunSuccessful: false,
            successMessage: '',
            dryRun: true,
            importedTasks: [],
            existingTasks: [],
            validChapterNumbers: [],
            fileName: '',
            sectionIds: [],
            productIds: [],
            skippedTasks: [],
            validTasks: [],
            issues: [],
            processing: false,
            showAlert: false,
            errorMessage: '',
        };
    },
    components: {
        pageHeader
    },
    watch: {
        selectedFile(newFile, oldFile) {
            if (newFile !== oldFile) {
                this.resetImportState();
            }
        }
    },
    mounted() {
        const productId = localStorage.getItem('product_id');
        const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

        axios.get(`/api/tasks/products/${productId}`, { headers })
            .then(response => {
                this.existingTasks = response.data;
            });

        axios.get('/api/chapters', { headers })
            .then(response => {
                this.validChapterNumbers = response.data.map(chapter => String(chapter.chapt_no).trim());
            })
            .catch(error => {
                console.error('Error retrieving chapters:', error);
            });
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'productPage', params: { productId: this.productId } });
        },
        handleError(error, customMessage = '') {
            console.error('Error:', error);
            if (error.response && error.response.data && error.response.data.message) {
                this.errorMessage = `${customMessage} ${error.response.data.message}`;
            } else if (error.message) {
                this.errorMessage = `${customMessage} ${error.message}`;
            } else {
                this.errorMessage = `${customMessage} An unknown error occurred.`;
            }
            this.showAlert = true;
            this.processing = false;
        },
        importFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.fileName = file.name;
            if (!file.type.includes('csv') && !file.name.endsWith('.csv')) {
                this.errorMessage = 'Please upload a .csv file.';
                this.showAlert = true;
                return;
            }

            Papa.parse(file, {
                delimiter: '|',
                skipEmptyLines: true,
                quoteChar: '"',
                encoding: "UTF-8",
                complete: (results) => {
                    this.entireFileRows = results.data;
                    this.previewRows = this.entireFileRows.slice(0, 5);
                },
                error: (err) => {
                    this.errorMessage = 'Error parsing CSV: ' + err.message;
                    this.showAlert = true;
                }
            });
        },
        handleImport() {
            this.dryRunSuccessful = false;
            this.processing = true;
            const processedTasks = this.processDataRows(this.entireFileRows);
            console.log('processedTasks');
            console.log(processedTasks);

            if (this.dryRun) {
                this.checkTasks(processedTasks);
                this.dryRunImport(processedTasks);
            } else {
                this.checkImportTasks(processedTasks);
            }

        },
        processDataRows(dataRows) {
            // Reset issues from any previous import attempt in this session
            this.issues = [];

            const rowsToProcess = this.ignoreFirstRow ? dataRows.slice(1) : dataRows;

            // Get max existing task_no
            const existingTaskNos = this.existingTasks
                .map(task => parseInt(task.task_no, 10))
                .filter(num => !isNaN(num));

            let nextTaskNo = existingTaskNos.length > 0 ? Math.max(...existingTaskNos) + 1 : 1;

            const processedTasks = rowsToProcess
                .filter(row => Array.isArray(row) && row.length > 0)
                .map((row, index) => {
                    if (index === 0 && this.isHeaderRow(row)) {
                        if (!this.ignoreFirstRow) {
                            this.issues.push({
                                message: `Row ${index + 1} appears to be a header row. Please check your file or enable "Ignore First Row".`,
                                row,
                                index,
                            });
                        }
                        // Skip processing this row but keep it for issues reporting
                        return null;
                    }
                    try {
                        const rawChapter = row[0].trim();
                        const chapt_no = /^\d+$/.test(rawChapter) && parseInt(rawChapter, 10) < 10
                            ? rawChapter.padStart(2, '0')
                            : rawChapter;
                        let task_no_raw = row[1] ? row[1].trim() : '';
                        let task_no = parseInt(task_no_raw, 10);

                        // Auto-assign if invalid or blank
                        if (isNaN(task_no)) {
                            task_no = nextTaskNo++;
                        }
                        const manob = row[2]?.trim().replace(/^"+|"+$/g, '').toUpperCase() || '';
                        let rawScope = row[3]?.trim().replace(/^"+|"+$/g, '').toUpperCase() || '';
                        const validScopes = ['LOC', 'INS', 'SGH', 'TS', 'FOT', 'MEL', 'R/I'];
                        const taskTokens = rawScope.split(',').map(token => token.trim());
                        const isValidTask = taskTokens.every(token => validScopes.includes(token));
                        const scope = isValidTask ? taskTokens.join(',') : ''; // <-- rebuilt, trimmed, normalized

                        const description = row[4]?.trim().replace(/^"+|"+$/g, '') || '';
                        const reference = row[5]?.trim().replace(/^"+|"+$/g, '') || '';
                        let rawSkill = row[6]?.trim().replace(/^"+|"+$/g, '').toUpperCase() || '';
                        if (rawSkill === 'B1 B2' || rawSkill === 'B1B2' || rawSkill === 'B1,B2') {
                            rawSkill = 'B1/B2';
                        }
                        const validCategories = ['B1', 'B2', 'B1/B2'];
                        const category = validCategories.includes(rawSkill) ? rawSkill : '';

                        const productId = parseInt(localStorage.getItem('product_id'), 10);

                        const task = {
                            task_no,
                            product_id: productId,
                            description,
                            reference,
                            scope,
                            // skill,
                            // P1,
                            // P2,
                            category,
                            manob,
                            chapt_no,
                            // is_exam
                        };

                        // Pass index as a second argument
                        this.validateTask(task, index, []);

                        return task;
                    } catch (error) {
                        console.error(`Error processing row ${this.ignoreFirstRow ? index + 1 : index}:`, row, error);
                        this.issues.push({ message: `Error processing row ${this.ignoreFirstRow ? index + 1 : index}: ${error.message}`, row, index });
                        return { error: true, row, message: error.message };
                    }
                });

            console.log('dryRun', this.dryRun);

            if (this.issues.length > 0) {
                this.handleIssues(this.issues, processedTasks);
            }

            return processedTasks.filter(task => task !== null);
        },
        isHeaderRow(row) {
            const headerKeywords = ["Task No", "Task Categories", "Subject", "Manual Reference", "Skill"];
            const headerMatch = headerKeywords.some(keyword =>
                row.some(cell => cell.trim().toLowerCase() === keyword.toLowerCase())
            );

            return headerMatch;
        },
        handleIssues(issues, processedTasks) {
            const uniqueIssues = [];

            issues.forEach(issue => {
                const isDuplicate = uniqueIssues.some(uniqueIssue =>
                    uniqueIssue.message === issue.message &&
                    uniqueIssue.task_no === issue.task_no &&
                    uniqueIssue.chapt_no === issue.chapt_no
                );

                if (!isDuplicate) {
                    uniqueIssues.push(issue);
                }
            });

            console.log('Filtered Issues before dispatching:', uniqueIssues);
            if (uniqueIssues.length) {
                this.$store.dispatch('setIssues', uniqueIssues);
                this.$store.dispatch('setImportedTasks', processedTasks);
                this.$store.dispatch('setFileName', this.fileName);
                this.$store.dispatch('setIgnoreFirstRow', this.ignoreFirstRow);

                // Warning-only issues don't stop the import, so no need to interrupt the
                // dry run with the Issues screen — only blocking issues do that.
                const hasBlockingIssues = uniqueIssues.some(issue => issue.severity !== 'warning');
                if (this.dryRun && hasBlockingIssues) {
                    this.$router.push({ name: 'IssuesDisplay', params: { productId: this.productId } });
                }
            }
        },
        dryRunImport(processedTasks) {
            let dryRunSkippedTasks = [];
            const duplicates = this.checkForDuplicates(processedTasks);
            dryRunSkippedTasks = duplicates.map(task => task.task_no);
            const warningRowCount = new Set(
                this.issues.filter(issue => issue.severity === 'warning').map(issue => issue.index)
            ).size;

            console.log("Dry Run Mode: These tasks would have been imported:", processedTasks);
            if (dryRunSkippedTasks.length > 0) {
                console.log("Duplicate tasks that would have been skipped:", dryRunSkippedTasks);
            } else if (warningRowCount > 0) {
                this.successMessage = `Dry Run Mode: ${processedTasks.length} tasks would have been imported.\n${warningRowCount} task(s) have a chapter number that is not in the Chapters table. They will still be imported, but should be checked.`;
                console.log(this.successMessage);
            } else {
                this.successMessage = `Dry Run Mode: ${processedTasks.length} tasks would have been imported. No issues found in the file.`;
                console.log(this.successMessage);
            }
            this.dryRunSuccessful = true;
            this.processing = false;
        },
        async batchImportTasks(validTasks, skippedTasks, processedTasks) {
            try {
                console.log('batchValid');
                console.log(validTasks);
                console.log('batchSkipped');
                console.log(skippedTasks);
                const token = localStorage.getItem('token');
                const headers = { Authorization: `Bearer ${token}` };
                const response = await axios.post('/api/tasks/batch', validTasks, { headers });
                const responseTasks = response.data.tasks;

                console.log('Batch Import Successful:', responseTasks);
                console.log(skippedTasks);

                this.$store.dispatch('setImportedTasks', processedTasks);
                this.$store.dispatch('setFileName', this.fileName);
                this.$store.dispatch('setSkippedTasks', skippedTasks);

                this.processing = false;
                this.errorMessage = '';
                this.showAlert = false;
                this.$router.push({ name: 'importSuccessful' });
            } catch (error) {
                this.handleError(error, 'Failed to import tasks.');
            }
        },
        areTasksEqual(task1, task2) {
            const keysToCheck = ['task_no', 'reference', 'skill', 'category', 'scope', 'manob', 'chapt_no'];

            for (let key of keysToCheck) {
                if (task1[key] !== task2[key]) {
                    return false;
                }
            }

            return true;
        },
        checkForDuplicates(importedTasks) {
            const duplicates = [];
            const seenTasks = [];

            for (let i = 0; i < importedTasks.length; i++) {
                const currentTask = importedTasks[i];

                // Check against existing tasks
                for (let existing of this.existingTasks) {
                    if (this.areTasksEqual(currentTask, existing)) {
                        duplicates.push({ task: currentTask, type: 'existing' });
                        break;
                    }
                }

                // Check against previously seen tasks in the import file
                for (let j = 0; j < seenTasks.length; j++) {
                    const seen = seenTasks[j].task;
                    if (this.areTasksEqual(currentTask, seen)) {
                        duplicates.push({
                            task: currentTask,
                            type: 'import',
                            originalRow: this.ignoreFirstRow ? seenTasks[j].index + 2 : seenTasks[j].index + 1
                        });
                        break;
                    }
                }

                // Add to seenTasks with index
                seenTasks.push({ task: currentTask, index: i });
            }

            return duplicates;
        },
        checkTasks(importedTasks, isDryRun = true) {
            this.skippedTasks = [];
            this.validTasks = [];
            console.log('importedTasks');
            console.log(importedTasks);
            const duplicates = this.checkForDuplicates(importedTasks);

            importedTasks.forEach((task, index) => {
                // If task.error exists, skip the validateTask call
                if (!task.error) {
                    // Pass the row number (index + 1) to validateTask
                    this.validateTask(task, this.ignoreFirstRow ? index : index + 1, duplicates);
                } else {
                    // Handle tasks with errors if needed (e.g., add to skippedTasks)
                    this.skippedTasks.push(task);
                }
            });

            this.handleIssues(this.issues, importedTasks, isDryRun);
        },
        checkImportTasks(importedTasks) {
            this.skippedTasks = [];
            this.validTasks = [];
            const duplicates = this.checkForDuplicates(importedTasks);

            importedTasks.forEach((task, index) => {
                // Pass the row number (index + 1) to validateTask
                this.validateTask(task, this.ignoreFirstRow ? index : index + 1, duplicates,);
            });

            // Use same issue-handling logic, but prevent route change
            this.handleIssues(this.issues, importedTasks, false); // false = not a dry run

            // Then proceed to actual import
            this.batchImportTasks(this.validTasks, this.skippedTasks, importedTasks);
        },
        validateTask(importedTask, index, duplicates) {
            try {
                const duplicateInfo = duplicates.find(d => this.areTasksEqual(d.task, importedTask));
                for (let key in importedTask) {
                    let value = importedTask[key];
                    if (key === "product_id") continue
                    switch (key) {
                        case "task_no":
                            if (value === undefined || value === null || value === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            // Check for invalid data types
                            else if (isNaN(value)) {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected number, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        case "chapt_no":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (this.validChapterNumbers.length > 0 && !this.validChapterNumbers.includes(value)) {
                                // Non-blocking: flagged for visibility, but the task is still imported.
                                this.issues.push({
                                    message: `Warning: Chapter "${value}" does not exist in the Chapters table. The task will still be imported — please add the chapter or correct the ATA value.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index,
                                    severity: 'warning',
                                });
                            }
                            break;
                        case "description":
                        case "reference":
                        case "skill":
                        case "category":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        case "scope":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else {
                                const scopePattern = ['LOC', 'INS', 'SGH', 'TS', 'FOT', 'MEL', 'R/I'];
                                // Split by comma, trim each token
                                const tokens = value.split(',').map(t => t.trim().toUpperCase());

                                // Check if all tokens are valid
                                const allValid = tokens.every(token => scopePattern.includes(token));

                                if (!allValid) {
                                    this.issues.push({
                                        message: `Invalid value for "${key}". Accepted values are 'LOC', 'SGH', 'TS', 'FOT', 'MEL', 'INS', 'R/I'`,
                                        task_no: importedTask.task_no,
                                        chapt_no: importedTask.chapt_no,
                                        index
                                    });
                                }
                            }
                            break;
                        case "manob":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (!['MT', 'AT'].includes(value)) {
                                this.issues.push({
                                    message: `Invalid value for "${key}". Accepted values are 'MT' or 'AT'.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        case "P1":
                        case "P2":
                            // Ensure value is a string before using trim()
                            value = value ? String(value) : '';  // Convert value to a string if it's not already

                            if (value.trim() === '' || value.trim() === '0') {
                                // If empty, set to 0
                                importedTask[key] = 0;
                            } else if (['1', 'x', 'X'].includes(value.trim())) {
                                // If 'X' or 'x', set to 1
                                importedTask[key] = 1;
                            } else {
                                // If anything else, log an error
                                this.issues.push({
                                    message: `Invalid value for "${key}". Accepted values are '1', '0', 'x', or empty (defaulted to '0').`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        default:
                            this.issues.push({
                                message: `Extra field "${key}" detected.`,
                                task_no: importedTask.task_no,
                                chapt_no: importedTask.chapt_no,
                                index
                            });
                    }
                }
                if (duplicateInfo) {
                    let message;
                    if (duplicateInfo.type === 'existing') {
                        message = `Row ${this.ignoreFirstRow ? parseInt(index) + 2 : parseInt(index) + 1}: Task already exists in the Practical Element (Duplicate record).`;
                    } else if (duplicateInfo.type === 'import') {
                        message = `Row ${this.ignoreFirstRow ? parseInt(index) + 2 : parseInt(index) + 1}: Task is a duplicate within the import file (first seen at row ${duplicateInfo.originalRow}).`;
                    }

                    this.issues.push({
                        message,
                        task_no: importedTask.task_no,
                        chapt_no: importedTask.chapt_no,
                        index
                    });
                }
                // Warning-level issues (e.g. unknown chapter) are shown to the user but don't block import.
                const hasBlockingIssues = this.issues.some(issue =>
                    issue.task_no === importedTask.task_no && issue.index === index && issue.severity !== 'warning'
                );
                if (!hasBlockingIssues) {
                    this.validTasks.push(importedTask);
                } else {
                    this.skippedTasks.push(importedTask);
                }
            } catch (error) {
                this.handleError(error, `Validation failed for Task No: ${importedTask.task_no}.`);
            }
        },
        resetImportState() {
            this.successMessage = null;
            this.previewRows = [];
            this.entireFileRows = [];
            this.processing = false;
            this.errorMessage = '';
            this.showAlert = false;
            this.fileName = '';
            this.processedTasks = [];
        }
    },
}
</script>

<style scoped>
.importButton[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.9;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

label {
    float: left;
    margin-bottom: 20px;
    margin-top: 0px;
}

.back-button {
    position: absolute;
    /* Adjust the top position as needed */
    right: 60px;
    /* Adjust the right position as needed */
    width: 100px;
    border-radius: 5px;
    background-color: #c1e0bf;
    font-size: 14px;
    border: 2px solid black;
    padding: 3px;
}

.back-button:hover {
    background-color: #abc7a9;
    cursor: pointer;
}
</style>